import React, {memo} from 'react';
import Breadcrumbs from "@/app/components/breadcrumbs";
import styles from "./styles.module.scss";
import UsersAndLocation from "@/app/components/users_and_location";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import {useMediaQuery} from "@/app/utils/custom_function";
import {TextBold16, TextBold20, ThirtyText} from "@/app/components/texts";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import Button from "@/app/components/button";
import {InvitationStatusEnum} from "@/app/api/invitation";
import {BreadcrumbsType} from "@/app/components/breadcrumbs/widget";
import {useInvitationPage} from "@/app/features/invitation_detail/slice";
import BottomSheet from "@/app/components/bottom_sheet/widget";
import Input from "@/app/components/input";
import LazyAssets from "@/app/utils/assets_widget";
import Dialog from "@/app/components/dialog/widget";
import ReviewForm from "@/app/components/review_form/widget";

const InvitationPage = () => {
  const isDesktop = useMediaQuery('(min-width:1024px)');
  const {
    state,
    onDeleteInvitations,
    goToChat,
    onCompleteInvitations,
    onAcceptInvitations,
    toggleShowReview,
    onSetReview,
    setRating,
    sendReview
  } = useInvitationPage();

  if (state.hasLoading) {
    return (<div className={styles.invitation}><CircularProgressIndicator isGreen/></div>);
  }
  if (state.hasError || !state.batch) {
    return (<div className={styles.invitation}><ThirtyText text={state.hasError || t(s.notInvited)}/></div>);
  }

  const {batch, location, reviews, users, areYouAuthor, youAccepted} = state;

  return (
    <div className={styles.invitation}>
      <Breadcrumbs items={[BreadcrumbsType.padel, BreadcrumbsType.createAMatch]}/>
      <UsersAndLocation users={users} location={location} reviews={reviews}/>
      {isDesktop ? <div className={styles.buttons}>
          <div className={styles.buttonsContent}>
            <ThirtyText text={t(s.createAMatch)}/>
            <TextBold20 text={t(s.afterOpponentsConfirm)}/>
          </div>
          {areYouAuthor && batch.status === InvitationStatusEnum.PENDING &&
              <Button text={t(s.deleteInvitation)} onClick={onDeleteInvitations} isRed isLoading={state.hasLoadingDelete}
                      isOutline/>}
          {batch.status === InvitationStatusEnum.ACCEPTED &&
              <Button text={t(s.goToChat)} onClick={goToChat} isGreen isLoading={state.hasLoadingGoToChat}/>}
          {areYouAuthor && batch.status === InvitationStatusEnum.ACCEPTED &&
              <Button text={t(s.completed)} onClick={onCompleteInvitations} isLoading={state.hasLoadingComplete}/>}
          {!youAccepted && !areYouAuthor && batch.status === InvitationStatusEnum.PENDING &&
              <Button text={t(s.acceptInvitation)} onClick={onAcceptInvitations} isLoading={state.hasLoadingAccept}/>}
          {!areYouAuthor && batch.status === InvitationStatusEnum.COMPLETED &&
              <Button text={t(s.leaveAReview)} onClick={toggleShowReview} isLoading={state.hasLoadingComplete}/>}
        </div> :
        <div className={styles.buttons}>
          {areYouAuthor && batch.status === InvitationStatusEnum.PENDING &&
              <Button text={t(s.deleteInvitation)} onClick={onDeleteInvitations} isRed
                      isLoading={state.hasLoadingDelete} isOutline/>}
          {batch.status === InvitationStatusEnum.ACCEPTED &&
              <Button text={t(s.goToChat)} onClick={goToChat} isGreen isLoading={state.hasLoadingGoToChat}/>}
          {areYouAuthor && batch.status === InvitationStatusEnum.ACCEPTED &&
              <Button text={t(s.completed)} onClick={onCompleteInvitations} isLoading={state.hasLoadingComplete}/>}
          {!youAccepted && !areYouAuthor && batch.status === InvitationStatusEnum.PENDING &&
              <Button text={t(s.acceptInvitation)} onClick={onAcceptInvitations} isLoading={state.hasLoadingAccept}/>}
          {!areYouAuthor && batch.status === InvitationStatusEnum.COMPLETED &&
              <Button text={t(s.leaveAReview)} onClick={toggleShowReview} isLoading={state.hasLoadingComplete}/>}
        </div>}
      <ReviewForm 
        isOpen={state.showReview ?? false}
        onClose={toggleShowReview}
        onSetReview={onSetReview}
        setRating={setRating}
        sendReview={sendReview}
        review={state.review}
        rating={state.rating}
        isLoading={state.hasLoadingSendReview}
        isDesktop={isDesktop}
      />
    </div>
  );
};

export default memo(InvitationPage);